import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography } from "@material-ui/core";
import { useTheme } from '../constants/themeProvider';


const CommonButton = (props) => {
    const { title, onClick, classStyleHeading, classStyleText } = props;
    const theme = useTheme();

    return (
       <Button style={{background: theme?.primaryColor}} className={classStyleHeading || ''} onClick={onClick}>
        <Box className={classStyleText || ''}>
            <Typography variant="inherit" style={{color: theme?.primaryFontText}}>
              {title}
              </Typography>
            </Box>
        </Button>
    )    
};

  CommonButton.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onClick: PropTypes.func,
    classStyleHeading: PropTypes.string,
    classStyleText: PropTypes.string,
  };

export default CommonButton;